import { Layout } from "react-grid-layout";

import { UpdatePageLayoutBodyInner, WidgetContainer } from "@/lib/api";

/** Resize floor for widget containers in the admin page grid. */
export const WIDGET_LAYOUT_MIN_W = 1;
export const WIDGET_LAYOUT_MIN_H = 6;

export const transformWidgetContainersToGridLayout = (
  widgetContainers: WidgetContainer[],
): Layout[] => {
  return widgetContainers.map((container) => ({
    i: container.id,
    w: container.width,
    h: container.height,
    x: container.position_x,
    y: container.position_y,
    // Floor for resizing; a container may never be shrunk below this.
    minW: WIDGET_LAYOUT_MIN_W,
    minH: WIDGET_LAYOUT_MIN_H,
  }));
};

export const transformGridLayoutToWidgetContainers = (
  gridLayout: Layout[],
): UpdatePageLayoutBodyInner[] => {
  return gridLayout.map((layout) => ({
    widget_container_id: layout.i,
    width: layout.w,
    height: layout.h,
    position_x: layout.x,
    position_y: layout.y,
  }));
};
